const SPLIT_WORD_CHARS = '[^a-zA-Z_]'

/*eslint-disable */
const operators = [
  'BINEAR\/[0-9]*',
  'BINEAR',
  'NEAR\/[0-9]*',
  'NEAR',
  '~[0-9]*'
]
/*eslint-disable */

export const booleanOperators = ['AND NOT', 'AND', '&amp;&amp;', '&&', 'OR', '[|]{2}' ];

const keywords = [
  'LIST_OR',
  'group:',
  'headline:',
  'content:',
  'search:',
  'provider_tags:'
]


const ranges = [
  'headline:{[" a-zA-Z0-9]* TO [" a-zA-Z0-9]*}',
  'content:{[" a-zA-Z0-9]* TO [" a-zA-Z0-9]*}',
  'provider_tags:{[" a-zA-Z0-9]* TO [" a-zA-Z0-9]*}'
]

export const DEFAULT_OPTIONS = {
  checkSpacing: true,
  classPrefix: 'q-hl-',
  stringHighlighters: [
    {
      name: 'wildcard',
      regex: /(\*|\?)/g
    }
  ],
  /*eslint-disable */
  highlighters: [
    {
      name: 'open_bracket',
      type: 'grouping',
      class: "not_double_clickable",
      regex: /({\{)/g
    },
    {
      name: 'close_bracket',
      type: 'grouping',
      regex: /(\}\})/g
    },
    {
      name: 'open_bracket',
      type: 'grouping',
      regex: /([(])/g
    },
    {
      name: 'close_bracket',
      type: 'grouping',
      regex: /([)])/g
    },
    {
      name: 'not',
      type: 'boolean_operator',
      regex: new RegExp(`(?:^|${SPLIT_WORD_CHARS})(?:AND NOT|NOT|!)(?=${SPLIT_WORD_CHARS}|$)|(?:^|${SPLIT_WORD_CHARS})(?:!)`, 'g')
    },
    {
      name: 'and',
      type: 'boolean_operator',
      regex: new RegExp(`(?:^|${SPLIT_WORD_CHARS})(?:AND|&amp;&amp;|&&)(?=${SPLIT_WORD_CHARS}|$)`, 'g')
    },
    {
      name: 'or',
      type: 'boolean_operator',
      regex: new RegExp(`(?:^|${SPLIT_WORD_CHARS})(?:OR|[\|]{2})(?=${SPLIT_WORD_CHARS}|$)`, 'g')
    },
    {
      name: 'keyword',
      type: 'range_search',
      regex: new RegExp(`(?:^|${SPLIT_WORD_CHARS})(?:${ranges.join('|')})(?=${SPLIT_WORD_CHARS}|$)`, 'g')
    },
    {
      name: 'keyword',
      type: 'field',
      regex: new RegExp(`(?:^|${SPLIT_WORD_CHARS})(?:${keywords.join('|')})(?=${SPLIT_WORD_CHARS}|$)*`, 'g')
    },
    {
      name: 'operator',
      type: 'proximity_search',
      regex: new RegExp(`(?:${operators.join('|')})`, 'g')
    },
    {
      name: 'string',
      type: 'phrase',
      regex: /(^"|^(\\{2})"|[^\\](\\{2})*").*?("|(\\{2})"|[^\\](\\{2})*")/g
    },
    {
      name: 'new_line',
      type: 'html_parsing',
      regex: /(\n|<br[ ]*[\/]?>)/g
    },
    {
      name: 'tab',
      type: 'html_parsing',
      regex: /(\t)/g
    }
  ]
  /*eslint-disable */
}